import { render } from "./backgroundone.vue?vue&type=template&id=435f19c7&scoped=true"
import script from "./backgroundone.vue?vue&type=script&lang=js"
export * from "./backgroundone.vue?vue&type=script&lang=js"

import "./backgroundone.vue?vue&type=style&index=0&id=435f19c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-435f19c7"

export default script